import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'
/* */
const { saveCreateProfile } = importer('Stores/Users/Select', null)
/* ACTIONS */
const UserActions = importer('Stores/Users/Actions')
const DonorActions = importer('Stores/Donors/Actions')
export default function * success ({ res }) {
  const sfid = yield res?.data?.sfid
  const personContactId = yield res?.data?.personContactId
  const savedProfile = yield select(saveCreateProfile)
  if (savedProfile) {
    const updatedProlife = yield { ...savedProfile, salesforceId: sfid || '' , personContactId : personContactId || '' }
    yield put(UserActions.register(updatedProlife))
  } else { yield put(DonorActions.registerGetDonorProfileFailure(Error('Try again later'))) }
}
